import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { Card, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { Alert } from "../Utilidades";

// Actions de Redux
import {
  contrasenaUsuarioAction,
  resetEditarContrasenaAction,
} from "../../redux/actions/usuarioActions";

const Contrasena = ({ onSubmit }) => {
  const dispatch = useDispatch();

  const [contrasenaActual, setContrasenaActual] = useState("");
  const [contrasenaNueva, setContrasenaNueva] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const formikRef = useRef(null);

  // Acceder al state del store
  const { loading, error, errorMessage, resultado } = useSelector(
    (state) => state.usuario
  );

  const { user } = useSelector((state) => state.login);

  const contrasenaSchema = Yup.object().shape({
    contrasenaActual: Yup.string().required("Requerido"),
    contrasenaNueva: Yup.string()
      .min(8, "Mínimo 8 caracteres")
      .max(10, "Máximo 10 caracteres")
      .required("Requerido"),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref("contrasenaNueva"), null],
        "Confirmación de contraseña no coincide"
      )
      .required("Requerido"),
  });

  // Confirmar si desea guardar la nueva contraseña
  const confirmarContrasena = (values, actions) => {
    // preguntar al usuario
    Swal.fire({
      title: "¿Está seguro que desea guardar la nueva contraseña?",
      text: "",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        const params = {
          usuarioId: user.usuario.uid,
          contrasenaActual: values.contrasenaActual,
          contrasenaNueva: values.contrasenaNueva,
        };
        dispatch(contrasenaUsuarioAction(params));
        resetForm();
      }
    });
  };

  const resetForm = () => {
    setContrasenaActual("");
    setContrasenaNueva("");
    setConfirmPassword("");
  };

  useEffect(() => {
    if (!loading && !error && resultado && resultado?.resultado) {
      dispatch(resetEditarContrasenaAction());
      Swal.fire({
        icon: "success",
        title: resultado?.msg,
        showConfirmButton: false,
        timer: 2500,
      });
    }
  }, [loading, error, resultado, dispatch]);

  // Se ejecuta al destruir el componente
  useEffect(() => {
    return () => {
      dispatch(resetEditarContrasenaAction());
    };
  }, [dispatch]);

  return (
    <div className="col-md-6 mt-3">
      <Card>
        <Card.Header>
          <h3 className="card-title">Cambiar Contraseña</h3>
        </Card.Header>
        <Card.Body>
          <Formik
            innerRef={formikRef}
            initialValues={{
              contrasenaActual: "",
              contrasenaNueva: "",
              confirmPassword: "",
            }}
            enableReinitialize={true}
            validationSchema={contrasenaSchema}
            onSubmit={(values, actions) => {
              confirmarContrasena(values, actions);
            }}
          >
            {({ errors, touched, values, handleChange }) => (
              <FormikForm>
                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">Contraseña actual</Card.Text>
                  <Form.Control
                    id="contrasenaActual"
                    name="contrasenaActual"
                    type="password"
                    value={contrasenaActual}
                    onChange={(e) => {
                      handleChange(e);
                      setContrasenaActual(e.target.value);
                    }}
                    placeholder="Contraseña actual"
                    isInvalid={
                      touched.contrasenaActual && !!errors.contrasenaActual
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.contrasenaActual}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">Nueva contraseña</Card.Text>
                  <Form.Control
                    id="contrasenaNueva"
                    name="contrasenaNueva"
                    type="password"
                    value={contrasenaNueva}
                    onChange={(e) => {
                      handleChange(e);
                      setContrasenaNueva(e.target.value);
                    }}
                    placeholder="Nueva contraseña"
                    isInvalid={
                      touched.contrasenaNueva && !!errors.contrasenaNueva
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.contrasenaNueva}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Card.Text className="fw-bold">
                    Confirmar nueva contraseña
                  </Card.Text>
                  <Form.Control
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => {
                      handleChange(e);
                      setConfirmPassword(e.target.value);
                    }}
                    placeholder="Confirmar nueva contraseña"
                    isInvalid={
                      touched.confirmPassword && !!errors.confirmPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
        </Card.Body>
        <Card.Footer
          style={{ backgroundColor: "transparent", borderTop: "none" }}
        >
          <Button
            variant="danger"
            className="btn-sm"
            onClick={() => {
              formikRef.current?.submitForm();
            }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Actualizando...
              </>
            ) : (
              "Actualizar"
            )}
          </Button>
          {!loading && error && (
            <Alert variant={"danger"} message={errorMessage} />
          )}
        </Card.Footer>
      </Card>
    </div>
  );
};

export default Contrasena;
